import { findCategories } from '@api/category';
import { Category } from '@interfaces/category';
import { useEffect, useState } from 'react';

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);

  const fetchCategories = async () => {
    const categories = await findCategories();
    setCategories(categories || []);
  };

  const categoryOptions = categories.map((category) => ({
    label: category.name,
    value: String(category.id),
    'data-testid': category.name,
  }));

  useEffect(() => {
    fetchCategories();
  }, []);

  return { categories, categoryOptions };
};
